import { OrderProcessingResult } from "../mvcapi/models/transactionprocessing/orderprocessingresult";
import { TSAPIService } from "./mvcapi";

// Prepare the order before stepping to the payment
export async function prepareStandbyOrder(mvcapi: TSAPIService, cartTotalValidation: number, shippingID: string): Promise<PrepareStandByOrderResponseModel> {
  return mvcapi.postCtl("orderprocessing/preparestandbyorder", {
    cartTotalValidation,
    shippingAddressID: shippingID
  });
}

// Process the transaction
export async function processTransaction(mvcapi: TSAPIService, encryptedTransactionID: string, paymentMethod: PaymentInfoModel, sendEmail: boolean, threeDSBTId: string = undefined): Promise<OrderProcessingResult>{
  return mvcapi.postCtl("orderprocessing/processtransaction", {
    encTrID: encryptedTransactionID,
    threeDSBTId: threeDSBTId,
    paymentMethod,
    sendEmail
  });
}

// 3D Secure
export async function process3DSAuthentication(mvcapi: TSAPIService, encryptedTransactionID: string, btId: string, deviceData: ThreeDSDeviceData, paymentMethod: PaymentInfoModel, sendEmail: boolean): Promise<Process3DSAuthenticationResult>{
  return mvcapi.postCtl("orderprocessing/process3dsauthentication", {
    encTrID: encryptedTransactionID,
    btId,
    deviceData,
    paymentMethod,
    sendEmail
  });
}




// ************************************************************
// Models
// ************************************************************

export enum PaymentInfoModelMethodEnum {
  NoPayment = "no_payment",
  CreditCard = "creditcard",
  CardStorage = "cardstorage"
}

export type PaymentInfoModel = {
  method: PaymentInfoModelMethodEnum,
  cardHolderName?: string,
  cardNumber?: string,
  cardExpMonth?: number,
  cardExpYear?: number,
  cvNumber?: string,
  cardHolderPostalCode?: string,
  cardHolderCountry?: string,
  cardHolderAddress1?: string,
  cardToken?: string
}
export type ThreeDSDeviceData = {
  colorDepth: number,
  javaEnabled: boolean,
  browserLanguage: string,
  screenHeight: number,
  screenWidth: number,
  userAgent: string,
  browserTime: Date,
  browserTimezoneZoneOffset: number,
}


export type Process3DSAuthenticationResult = {
  isSuccess: boolean;
  result: Process3DSAuthenticationResultValue;
  challengeRequest: Process3DSAuthenticationChallengeRequest;
};


export type Process3DSAuthenticationChallengeRequest = {
  url: string,
  encodedData: string,
  iframeWidth: number,
  iframeHeight: number,
};

export enum Process3DSAuthenticationResultValue
{
  FRICTION_LESS = "FRICTION_LESS",
  TRANSACTION_FAILED_TO_COMPLETE = "TRANSACTION_FAILED_TO_COMPLETE",
  PAYMENT_REFUSED = "PAYMENT_REFUSED",
  CHALLENGE_REQUIRED = "CHALLENGE_REQUIRED",
}


export type PrepareStandByOrderResponseModel = {
  isSuccess: boolean,
  cartIsExpired: boolean,
  invalidTicketNumberOrAmount: boolean,
  productNotInSale: boolean,
  noPaymentNeeded: boolean,
  deliveryMethodNotSet: boolean,
  totalWithoutPrepaidCardAmount: number,
  productsNotInSaleName: string,
  encryptedUID: string
}